module.exports = __webpack_public_path__ + "public/files/img/results_places.c357f9f2.jpeg";